"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = exports.setFileOptionsError = exports.setFileOptions = exports.loadCharacters = exports.loadFileOptions = exports.filterCharacters = exports.setChosen = exports.hideModal = exports.showModal = undefined;

var _requests = require("../libs/utils/requests");

var _ModalsActionTypes = require("../constants/action-types/ModalsActionTypes");

var actionTypes = _interopRequireWildcard(_ModalsActionTypes);

var _ChallengeData = require("../constants/ChallengeData");

var _challenge = require("../selectors/challenge");

var _game = require("../selectors/game");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var showModal = exports.showModal = function showModal(_ref) {
  var modalType = _ref.modalType,
      modalProps = _ref.modalProps,
      meta = _ref.meta;
  return {
    type: actionTypes.SHOW_MODAL,
    payload: {
      modalType: modalType,
      modalProps: modalProps
    },
    meta: meta
  };
};

var hideModal = exports.hideModal = function hideModal() {
  return {
    type: actionTypes.HIDE_MODAL
  };
};

var setChosen = exports.setChosen = function setChosen(chosen) {
  return {
    type: actionTypes.SET_CHOSEN,
    payload: {
      chosen: chosen
    }
  };
};

var filterCharacters = exports.filterCharacters = function filterCharacters(search) {
  return {
    type: actionTypes.FILTER_CHARACTERS,
    payload: {
      search: search
    }
  };
}; //TODO: this isn't the right action flow, dispatch action, and handle in reducer?
//TODO: should be called from showModal maybe, and then a thunk based on this success - either showing modal or showing error


var loadFileOptions = exports.loadFileOptions = function loadFileOptions() {
  return function (dispatch, getState, _ref2) {
    var uploadContent = _ref2.uploadContent;
    var state = getState();
    var challenge = (0, _challenge.selectChallengeName)(state);
    var destination = uploadContent.loadFileOptionsUrl;
    var fetchOptions = {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    };
    var query = {
      user: (0, _game.selectThisPlayerName)(state),
      path: challenge
    };
    return (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions,
      query: query
    }).then(function (response) {
      return dispatch(setFileOptions(response, challenge));
    }).catch(function (err) {
      return dispatch(setFileOptionsError(err));
    });
  };
};

var loadCharacters = exports.loadCharacters = function loadCharacters() {
  return function (dispatch, getState, _ref3) {
    var uploadContent = _ref3.uploadContent;
    var state = getState();
    var challenge = _ChallengeData.CHARACTER_BUILDING_CHALLENGE;
    var destination = uploadContent.loadFileOptionsUrl;
    var fetchOptions = {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    };
    var query = {
      user: state.meta.username,
      path: challenge
    };
    return (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions,
      query: query
    }).then(function (response) {
      return dispatch(setFileOptions(response, challenge));
    }).catch(function (err) {
      return dispatch(setFileOptionsError(err));
    });
  };
};

var setFileOptions = exports.setFileOptions = function setFileOptions(files, type) {
  return {
    type: actionTypes.SET_FILE_OPTIONS,
    payload: {
      files: files,
      type: type
    }
  };
};

var setFileOptionsError = exports.setFileOptionsError = function setFileOptionsError(err) {
  return {
    type: actionTypes.SET_FILE_OPTIONS_ERROR,
    payload: {
      err: err
    }
  };
};

var handleError = exports.handleError = function handleError(err) {
  return {
    type: actionTypes.HANDLE_INPUT_ERROR,
    payload: {
      err: err
    }
  };
};